import { api } from '@/api'

export default {
  getMarkup: (locationId: number) => api.$get(`/locations/${locationId}/material_markups`)
}
